import React from 'react'
import { Range, getTrackBackground } from 'react-range'
import { convertPrice } from '../lib/utils'
import useMediaQuery from '../../../utils/publicApi'
import styles from './priceRange.module.scss'

const STEP = 1
const MIN = 1
const MAX = 11

const PriceRange = ({ setNewRoute, values }) => {
  const isMobile = useMediaQuery('(max-width:600px)')

  return (
    <div className={styles.priceInput}>
      <output> {values[0] ? convertPrice(values[0]) : 'All Prices'}</output>

      <Range
        values={values}
        step={STEP}
        min={MIN}
        max={MAX}
        onChange={values => setNewRoute('price', values)}
        renderMark={({ props, index }) => (
          <div
            {...props}
            style={{
              ...props.style,

              width: '3px',

              backgroundColor: index * STEP > values[0] ? '#00ad66' : '#ccc'
            }}
          />
        )}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: '36px',
              display: 'flex',
              width: isMobile ? '100%' : '85%',
              marginLeft: isMobile ? '0px' : '10px'
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: '2px',
                width: '100%',
                borderRadius: '4px',
                background: getTrackBackground({
                  values,
                  colors: ['#00ad66', '#ccc'],
                  min: MIN,
                  max: MAX
                }),
                alignSelf: 'center'
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props }) => <div {...props} className={styles.thumb} />}
      />
    </div>
  )
}

export default PriceRange
